import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import ChevronLeftIcon from './icons/ChevronLeft';

const Container = styled.div`
  stroke: black;
  margin-right: 1rem;
`;

type Props = {
  backTo: string;
};
const BackTo: FC<Props> = ({ backTo }) => {
  return (
    <Container>
      <Link to={backTo}>
        <ChevronLeftIcon />
      </Link>
    </Container>
  );
};

export default BackTo;
